import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

export const RouteLoadingFallback: React.FC = () => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
    <CircularProgress />
  </Box>
);
